export default __webpack_public_path__ + "static/media/22.73a12e62.png";